import { h } from 'preact';
import { Text } from 'preact-i18n';
import { calcChange, formatNumber, formatLastTradeTime } from '../../lib/util';
import { StockChartWithIntervals } from '../stock-chart';
import { getGoodPrevClose } from '../../lib/util-stock-price';
import config from '../../defaults';
import style from './style';

const StockChartDetails = ({ stockData, symbol }) => {
	let name = stockData.Name || stockData.Symbol || symbol;
	let goodPrevClose = getGoodPrevClose(stockData);

	let change = calcChange(stockData.Open,goodPrevClose);
	let changePrice = formatNumber(change.price, { Decimals: 2, Default: '$0.00', Prefix: '$' });
	let prevClose = formatNumber(goodPrevClose, { Decimals: 2, Default: '0.00' });
	let open = formatNumber(stockData.Open, { Decimals: 2, Default: '0.00' });
	let lastTrade = formatLastTradeTime(stockData.LastTradeTime);

	let analysis;
	if (change.price > 0) {
		if (change.price > 5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.gappedUp" /> <span class={style.positive}>{changePrice}</span> <Text id="stock-open-analysis.overnightOpeningAt" /> <span class={style.highlight}>{open}</span> <Text id="stock-open-analysis.offOfAPreviousCloseOf" /> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else if (change.price > 0.5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.openedAt" /> <span class={style.highlight}>{open}</span> <Text id="stock-open-analysis.todayAnIncreaseOf" /> <span class={style.positive}>{changePrice}</span> <Text id="stock-open-analysis.fromThePreviousCloseOf" /> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.openedSlightlyUpTodayIncreasing" /> <span class={style.positive}>{changePrice}</span> <Text id="stock-open-analysis.fromThePreviousCloseOf" /> <span class={style.highlight}>{prevClose}</span></p>;
		}
	}
	else if (change.price < 0) {
		if (change.price < -5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.sharesDroppedOvernightTo" /> <span class={style.highlight}>{open}</span><Text id="stock-open-analysis.aDeclineOf" /> <span class={style.negative}>{changePrice}</span> <Text id="stock-open-analysis.fromThePreviousCloseOf" /> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else if (change.price < -0.5) {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.movedDownwardBy" /> <span class={style.negative}>{changePrice}</span> <Text id="stock-open-analysis.pointsOpeningAt" /> <span class={style.highlight}>{open}</span> <Text id="stock-open-analysis.todayComparedToAPreviousCloseOf" /> <span class={style.highlight}>{prevClose}</span></p>;
		}
		else {
			analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.openedSlightlyDownTodayDecreasing" /> <span class={style.negative}>{changePrice}</span> <Text id="stock-open-analysis.to" /> <span class={style.highlight}>{open}</span></p>;
		}
	}
	else if (stockData.Volume > 0) {
		analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.sharesOpenedFlatTodayAt" /> <span class={style.highlight}>{open}</span></p>;
	}
	else {
		analysis = <p><span class={style.highlight}>{name}</span> <Text id="stock-open-analysis.sharesHaveNotTradedSince" /> <span class={style.highlight}>{lastTrade}</span></p>;
	}

	return (
		<div class={`${style['stock-chart-details']} ${style['table-when-wide']}`}>
			<div class="chart-col">
				<div class="box-label"><Text id="stock-details.stockChart">Stock Chart</Text></div>
				<StockChartWithIntervals symbol={symbol} width="500" height="300" {...config.chart} />
			</div>
			<div class="details-col">
				<div class="box-label"><Text id="stock-details.atTheOpen">At the Open</Text></div>
				{ analysis }
				<div class={style.detail}>
					<div class={style.row}>
						<div class={style.label}><Text id="stock-details.open" /></div>
						<div class={style.value}>{ formatNumber(stockData.Open, { Decimals: 2, Default: '0.00' }) }</div>
					</div>
				</div>
				<div class={style.detail}>
					<div class={style.row}>
						<div class={style.label}><Text id="stock-details.previousClose" >Previous Close</Text></div>
						<div class={style.value}>{ formatNumber(stockData.PrevClose, { Decimals: 2, Default: '0.00' }) }</div>
					</div>
				</div>
				<div class={style.detail}>
					<div class={style.row}>
						<div class={style.label}><Text id="stock-details.volume" /></div>
						<div class={style.value}>{ formatNumber(stockData.Volume, { Decimals: 0, Default: '0', Comma: true }) }</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default StockChartDetails;
